import { styled } from '@mui/material/styles';
import SaveIcon from '@mui/icons-material/Save';
import { DeleteIcon } from 'assets/images/icons';

const styledIcon = IconComponent =>
    styled(IconComponent)({
        width: 18,
        height: 18,
        marginRight: 8,
        '& path': {
            fill: 'rgba(0, 0, 0, 0.6)',
        },
    });

export const StyledSaveIcon = styledIcon(SaveIcon);
export const StyledDeleteIcon = styledIcon(DeleteIcon);
